import { useEffect } from "react";
import colors from '../../template/Colors';
import {createUseStyles} from "react-jss";

const styles = {
    '@global' : {
        div : {
            display : 'flex',
            flexDirection : 'column',
            backgroundColor : colors.charcoal,
            justifyContent : 'center',
            alignItems : 'center',
            textAlign : 'center',
            width : '100vw',
            height : '100vh',
            color : 'white',
            fontSize : 24,
            '& a' : {
                color : colors.paleBlue,
                '&:hover' :  {
                    color : colors.azure
                }
            }
        }
    }
}

const useStyle = createUseStyles(styles)

export default function Resume() {

    useStyle();

    useEffect(() => {
        window.location.replace("/files/thomas-galletta-resume.pdf");
    }, []);

    return <div>
        <p>Redirecting...</p>
        <p>Redirect not working? Click <a href={'/files/thomas-galletta-resume.pdf'} download={"thomas-galletta-resume.pdf"}>here</a> to download</p>
</div>
    ;
}
